/*
 * Ryan O'Dowd
 * 2023-10-31
 * © Copyright 2023 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */
import {
  Platform,
} from 'react-native';

const skeletonDefaults = { // @TODO: abstract with Verse/styles.native.js
  height: 18,
  marginTop: 4,
  marginBottom: 4,
  marginRight: 16,
  opacity: 0.4,
};

const getStyles = ({fonts, globalScale, colors, safeAreaInsets}) => {
  return {
    container: {
      flex: 1,
      paddingTop: 16,
      paddingHorizontal: 16,
    },
    mainListContainer: { // @TODO: abstract
      paddingBottom: safeAreaInsets.bottom,
    },

    section: { // @TODO: combine with web
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: globalScale * 16,
    },
    sectionTitle: {
      fontFamily: fonts.primaryBold,
      color: colors.white,
      fontSize: globalScale * 20,
      justifyContent: 'center',
      marginBottom: 32,
    },
    textWrapper: {
      flex: 1,
    },
    statsWrapper: {
      display: Platform.OS === 'web' ? 'inline' : 'flex',
      alignItems: 'flex-end',
      justifyContent: 'flex-start',
      flexWrap: 'wrap',
      // @TODO: marginHorizontal: globalScale * 8,
      marginVertical: globalScale * 8,
      fontSize: globalScale * 16,
      lineHeight: globalScale * 20, // @TODO: same as statText.fontSize
      color: colors.white,
    },
    statText: {
      display: Platform.OS === 'web' ? 'inline' : 'flex',
      fontFamily: fonts.primaryBold,
      color: colors.accent,
      fontSize: globalScale * 20, // @TODO: big looks good but has to be laid out well (and maybe give a max size because of $globalScale)
      marginTop: Platform.OS === 'web' ? 0 : globalScale * -8,
      height: Platform.OS === 'web' ? globalScale * 20 : globalScale * 8,
      maxHeight: Platform.OS === 'web' ? globalScale * 20 : globalScale * 8,
    },
    graphic: {
      resizeMode: 'contain',
    },
    elephantGraphic: {
      width: 110,
      height: 110,
      marginLeft: 8,
    },
    brainGraphic: {
      width: 110,
      height: 190,
      marginRight: 8,
    },
    shareWrapper: {
      marginVertical: 8,
    },

    skeletonLine1: { // @TODO: abstract with Verse/styles.native.js
      ...skeletonDefaults,
      width: '95%',
      alignSelf: 'flex-start',
    },
    skeletonLine2: {
      ...skeletonDefaults,
    },
    skeletonLine3: {
      ...skeletonDefaults,
      width: '75%',
      marginBottom: 12,
    },
    downloadCtaWrapper: { // @TODO: abstract with LandingPage
      display: 'flex',
      flexGrow: 1,
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      paddingTop: 64,
      paddingBottom: 64,
    },
  };
};

export default getStyles;
